import Home from '../Home'
import About from '../About'
import Projects from '../Projects'
import Contact from '../Contact'

const Main = () => {
  return (
    <div>
      <Home />
      <About />
      <Projects />
      <Contact />
    </div>
  )
}

export default Main
